// Opens/closes the "What is Blue?" info popup for the product page's blue
// cashback widget (see snippets/blue-cashback.liquid). The popup is
// relocated to <body> on connect for the same reason gift-options.js does
// this for its drawers - position: fixed breaks if an ancestor's
// scroll-reveal animation leaves a lingering transform, which turns that
// ancestor into the containing block for fixed descendants instead of the
// viewport.
class BlueCashbackWidget extends HTMLElement {
  connectedCallback() {
    this.popup = this.querySelector('[data-blue-cashback-popup]');
    this.toggleButton = this.querySelector('[data-blue-cashback-info-toggle]');
    this.closeButtons = this.querySelectorAll('[data-blue-cashback-info-close]');

    if (!this.popup) return;

    if (this.popup.parentElement !== document.body) {
      document.body.appendChild(this.popup);
    }

    if (this.toggleButton) this.toggleButton.addEventListener('click', () => this.open());
    this.closeButtons.forEach((button) => button.addEventListener('click', () => this.close()));

    this.popup.addEventListener('click', (event) => {
      if (event.target === this.popup) this.close();
    });
    this.popup.addEventListener('keyup', (event) => {
      if (event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });
  }

  open() {
    if (!this.popup) return;
    // Only lock scroll if nothing else already has - e.g. this could open
    // while the cart drawer is also open, and closing this shouldn't
    // unlock scroll out from under that still-open drawer.
    this.bodyOverflowWasAlreadyHidden = document.body.classList.contains('overflow-hidden');
    this.popup.hidden = false;
    document.body.classList.add('overflow-hidden');
    if (typeof trapFocus === 'function') {
      trapFocus(this.popup, this.popup.querySelector('[data-blue-cashback-info-close]'));
    }
  }

  close() {
    if (!this.popup) return;
    this.popup.hidden = true;
    if (!this.bodyOverflowWasAlreadyHidden) document.body.classList.remove('overflow-hidden');
    if (typeof removeTrapFocus === 'function') removeTrapFocus(this.toggleButton);
  }
}

if (!customElements.get('blue-cashback-widget')) {
  customElements.define('blue-cashback-widget', BlueCashbackWidget);
}
